<script setup lang="ts">
import {
	ModalWindows,
	Notifications,
	NotificationWindow,
	Recommendation,
	useCardLibStore,
	useDecorationSync,
	useMainLibStore,
	useModulesLibStore,
	useThemeStore,
} from "@innoclouds/shared";
import { computed, watch } from "vue";
import { RouterView } from "vue-router";
import LikeToast from "./components/likeToast/LikeToast.vue";
import OrderCompleted from "./components/orderCompleted/OrderCompleted.vue";
import { useScheduleNotification } from "./composables/useScheduleNotification";
import { useCardStore } from "./store/modules/card/card";

useScheduleNotification();
useDecorationSync({ precache: false });

const cardStore = useCardStore();
const cardStoreLib = useCardLibStore();
const themeStore = useThemeStore();
const modulesLibStore = useModulesLibStore();
const mainLibStore = useMainLibStore();

const showNotification = computed({
	get: () => modulesLibStore.is_notification_lib || mainLibStore.is_18_above_content,
	set(value: boolean) {
		if (!value) {
			modulesLibStore.notificationData_lib.textNotification = "";
			modulesLibStore.notificationData_lib.buttonAccept = null;
			modulesLibStore.is_notification_lib = false;
			mainLibStore.is_18_above_content = false;
		}
	},
});

watch(
	() => [cardStoreLib.dataUpSale, cardStoreLib.isAddToCard],
	(newDataUpsale) => {
		try {
			if (newDataUpsale[0].length > 0 && newDataUpsale[1]) {
				cardStoreLib.isUpSale = true;
			} else {
				cardStoreLib.isUpSale = false;
			}
		} catch (e) {
			console.warn(e, "[Error App watch]");
		}
	},
);
</script>

<template>
	<OrderCompleted />
	<RouterView />
	<LikeToast />
	<ModalWindows v-if="cardStoreLib.isUpSale" :visible="cardStoreLib.isUpSale">
		<Recommendation closeCurrentCard="" :openCurrentCard="cardStore.takeCurrentCard" :qr_menu="true" />
	</ModalWindows>
	<Teleport to="body">
		<NotificationWindow
			v-model:visible="showNotification"
			:textNotificationDefault="modulesLibStore.notificationData_lib.textNotification"
			:backgroundColor="themeStore.data?.accent_color || '#FF6D2E'"
			:buttonAccept="modulesLibStore.notificationData_lib?.buttonAccept || null"
			:type="mainLibStore.is_18_above_content"
		/>
	</Teleport>
	<Teleport to="body">
		<Notifications />
	</Teleport>
</template>

<style lang="scss">
  @use './normalize.scss';
  @use './global.scss';
</style>
